
import {Component, Prop, Vue} from "vue-property-decorator";
import PaymentArticlesUpdateForm from "@/form/finance/payment_articles/PaymentArticlesUpdateForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
@Component({
  components: {FormGroup},
})
export default class PaymentArticlesUpdateFormComponent extends Vue {
  @Prop() form!: PaymentArticlesUpdateForm;

}
